import { easeBackInOut } from "d3";
import { IconLayer } from "@deck.gl/layers";
import { data } from "../../data/airbasedata";

export const createAirbaseLayersMob = (currentSlide) => {
  const iconAtlas = 'assets/shahedicon.png'; // Provide your icon atlas path here
  const ICON_MAPPING = {
    marker: { // Use the name of the icon you'd like to display
      x: 0, // Starting x coordinate of the icon in the atlas
      y: 0, // Starting y coordinate of the icon in the atlas
      width: 704, // Width of the icon
      height: 624, // Height of the icon
      anchorY: 624, // Usually set to the icon's height to anchor the bottom of the icon to the coordinate
      mask: true,
    }
  };

  const getIconSize = (d) => {
    if (Number(d.slideNumMob) === Number(currentSlide.index)) {
      return 10;
    } else {
      return 0;
    }
  };

  const AirbaseData = new IconLayer({
    id: "icon-layer-path-",
    data,
    iconAtlas: 'assets/shahedicon.png',
    iconMapping: ICON_MAPPING,  
    pickable: true, 
    getIcon: d => 'marker',
    getPosition: d => d.coordinates,
    getIcon: d => 'myIcon', // Use the name of the icon from the mapping
    getSize: d => getIconSize (d), 
    getIcon: d => 'marker',
    getAngle: d => d.rotation,
    sizeScale: 5,
    updateTriggers: {
      getSize: [currentSlide.index] // This tells deck.gl to re-run getSize whenever currentSlide.index changes
    }
  });

  return AirbaseData;
};
